export default {
  apiUrl: 'https://api.ama-loc.fr/api',
}
